import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ApiService } from '../../api/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormactionService } from '../../api/formaction.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from "@angular/cdk/collections";
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-adminreport',
  templateUrl: './adminreport.component.html',
  styleUrls: ['./adminreport.component.css']
})
export class AdminreportComponent implements OnInit {

  public pduRes_RejListTable: any;
  public pduRes_BulkListTable: any;

  public query: string = '';
  public page: number = 1;
  public offset: number = 5;
  public pageEvent: any;
  totallength:any = 1 ;

  public query_mat_two: string = '';
  public page_mat_two: number = 1;
  public offset_mat_two: number = 5;
  public pageEvent_mat_two: any;
  totallength_mat_two:any = 1 ;


  public query_mat_three: string = '';
  public page_mat_three: number = 1;
  public offset_mat_three: number = 5;
  public pageEvent_mat_three: any;
  totallength_mat_three:any = 1 ;

  @ViewChild('t1Sort') t1Sort!: MatSort;
  @ViewChild('t1Paginator') t1Paginator!: MatPaginator;

  @ViewChild('b1Sort') b1Sort!: MatSort;
  @ViewChild('b1Paginator') b1Paginator!: MatPaginator;

  @ViewChild('c1Sort') c1Sort!: MatSort;
  @ViewChild('c1Paginator') c1Paginator!: MatPaginator;

  displayedColumns_view = ['ticketId', 'ccrefno', 'ccrefnostatus', 'ccorder', 'ccdate', 'ccverify', 'admin_status',  'action'];
  SRC_SELECTED_VIEW: Element_View[] = [];
  DATA_SELECTED_VIEW = Object.assign(this.SRC_SELECTED_VIEW);
  dataSource_view = new MatTableDataSource<Element_View>(this.DATA_SELECTED_VIEW);
  selected_view = new SelectionModel<Element_View>(true, []);
  public int_index_edit_view: any;

  displayedColumns_bulkview = ['ticketId', 'ccrefno', 'ccrefnostatus', 'ccorder', 'ccdate', 'ccverify', 'admin_status',   'action'];
  SRC_SELECTED_BULKVIEW: Element_BulkView[] = [];
  DATA_SELECTED_BULKVIEW = Object.assign(this.SRC_SELECTED_BULKVIEW);
  dataSource_bulkview = new MatTableDataSource<Element_BulkView>(this.DATA_SELECTED_BULKVIEW);
  selected_bulkview = new SelectionModel<Element_BulkView>(true, []);


  displayedColumns_dirnimiview = ['ticketId', 'ccrefno', 'ccrefnostatus', 'ccorder', 'ccdate', 'paymethod', 'entrydate', 'amount', 'admin_status',   'action'];
  SRC_SELECTED_DIRNIMIVIEW: Element_DirnimiView[] = [];
  DATA_SELECTED_DIRNIMIVIEW = Object.assign(this.SRC_SELECTED_DIRNIMIVIEW);
  dataSource_dirnimiview = new MatTableDataSource<Element_DirnimiView>(this.DATA_SELECTED_DIRNIMIVIEW);
  selected_dirnimiview = new SelectionModel<Element_DirnimiView>(true, []);

  constructor(private formBuilder: FormBuilder, private api: ApiService, private router: Router, private formaction: FormactionService) { }


  ngOnInit(): void {

    // this.api.shipped_verified_list().subscribe((result: any) => {
    //   this.pduRes_RejListTable = result;

    //   this.SRC_SELECTED_VIEW = result;

    //   //console.log(this.SRC_SELECTED_VIEW)

    //   this.DATA_SELECTED_VIEW = Object.assign(this.SRC_SELECTED_VIEW);
    //   this.dataSource_view = new MatTableDataSource<Element_View>(this.DATA_SELECTED_VIEW);

    //   this.dataSource_view.paginator = this.t1Paginator;
    //   this.dataSource_view.sort = this.t1Sort;

    // })




    // this.api.listbulkticketId().subscribe((result: any) => {

    //   console.log(result);

    //   this.pduRes_BulkListTable = result;

    //   this.SRC_SELECTED_BULKVIEW = result;

    //   console.log(this.SRC_SELECTED_BULKVIEW)

    //   this.DATA_SELECTED_BULKVIEW = Object.assign(this.SRC_SELECTED_BULKVIEW);
    //   this.dataSource_bulkview = new MatTableDataSource<Element_BulkView>(this.DATA_SELECTED_BULKVIEW);

    //   this.dataSource_bulkview.paginator = this.b1Paginator;
    //   this.dataSource_bulkview.sort = this.b1Sort;

    // })



  }

  ngAfterViewInit() {

    this.dataLoader();

    this.dataLoader_mat_two();

    this.dataLoader_mat_three();
  }


  dataLoader(){

    // this.api.shipped_verified_list_count(this.query, this.page, this.offset).subscribe((result: any) => {
    //   //console.log(result[0]['count'])
      
    //   this.totallength = result[0]['count'];
    //   console.log(this.totallength)
    // });
    this.api.shipped_verified_list(this.query, this.page, this.offset).subscribe((result: any) => {
    
      this.dataSource_view = new MatTableDataSource(result);
      this.dataSource_view.paginator = this.t1Paginator;
      this.dataSource_view.sort = this.t1Sort;
      //this.totallength = result[0]['count'];

      this.api.shipped_verified_list_count(this.query, this.page, this.offset).subscribe((result: any) => {
        //console.log(result[0]['count'])
        
        this.totallength = result[0]['count'];
        console.log(this.totallength)
      });


    })
  }

  pageChanged(event: any) {

    
    this.page = parseInt(event.pageIndex) + 1;
    this.offset = parseInt(event.pageSize);
    // this.totallength = 5000;
    // this.dataLoader();
console.log(this.page + " , " + this.offset)
    this.api.shipped_verified_list(this.query, this.page, this.offset).subscribe((result: any) => {
      this.dataSource_view = new MatTableDataSource(result);
    })

    
  }

  dataLoader_mat_two(){
    this.api.listbulkticketId(this.query_mat_two, this.page_mat_two, this.offset_mat_two).subscribe((result: any) => {
      this.dataSource_bulkview = new MatTableDataSource(result);
      this.dataSource_bulkview.paginator = this.b1Paginator;
      this.dataSource_bulkview.sort = this.b1Sort;

      this.api.listbulkticketId_count(this.query_mat_two, this.page_mat_two, this.offset_mat_two).subscribe((result: any) => {
        this.totallength_mat_two = result[0]['count'];
        console.log(this.totallength_mat_two)
      });
    });
  }

  dataLoader_mat_three(){
    this.api.listDirnimiticketId(this.query_mat_three, this.page_mat_three, this.offset_mat_three).subscribe((result: any) => {
      this.dataSource_dirnimiview = new MatTableDataSource(result);
      this.dataSource_dirnimiview.paginator = this.c1Paginator;
      this.dataSource_dirnimiview.sort = this.c1Sort;

      this.api.listDirnimiticketId_count(this.query_mat_three, this.page_mat_three, this.offset_mat_three).subscribe((result: any) => {
        this.totallength_mat_three = result[0]['count'];
        console.log(this.totallength_mat_three)
      });
    });
  }

  pageChanged_mat_two(event: any) {

    
    this.page_mat_two = parseInt(event.pageIndex) + 1;
    this.offset_mat_two = parseInt(event.pageSize);
    // this.totallength = 5000;
    // this.dataLoader();
    this.api.listbulkticketId(this.query_mat_two, this.page_mat_two, this.offset_mat_two).subscribe((result: any) => {
      this.dataSource_bulkview = new MatTableDataSource(result);
    })

    
  }

  pageChanged_mat_three(event: any) {

    
    this.page_mat_three = parseInt(event.pageIndex) + 1;
    this.offset_mat_three = parseInt(event.pageSize);
    // this.totallength = 5000;
    // this.dataLoader();
    this.api.listDirnimiticketId(this.query_mat_three, this.page_mat_three, this.offset_mat_three).subscribe((result: any) => {
      
      this.dataSource_dirnimiview = new MatTableDataSource(result);
    })

    
  }

  // applyFilterView(filterValue: any) {
  //   filterValue = filterValue.target.value.trim(); // Remove whitespace
  //   filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
  //   this.dataSource_view.filter = filterValue;
  // }


  // applyFilterView(filterValue: any) {
  //   filterValue = filterValue.target.value.trim(); // Remove whitespace
  //   filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
  //   this.dataSource_view.filter = filterValue;
  // }

  applyFilterView(filterValue: any) {
    filterValue = filterValue.target.value.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches

    this.api.shipped_verified_list(filterValue, this.page, this.offset).subscribe((result: any) => {
      this.dataSource_view = new MatTableDataSource(result);
      this.dataSource_view.paginator = this.t1Paginator;
      this.dataSource_view.sort = this.t1Sort;
      //this.totallength = result[0]['count'];

      this.api.shipped_verified_list_count(filterValue, this.page, this.offset).subscribe((result: any) => {
  
        this.totallength = result[0]['count'];
      });

      
    })

   // this.dataSource_view.filter = filterValue;

    
  }



  // applyFilterBulkView(filterValue: any) {
  //   filterValue = filterValue.target.value.trim(); // Remove whitespace
  //   filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
  //   this.dataSource_bulkview.filter = filterValue;
  // }

  applyFilterBulkView(filterValue: any) {
    filterValue = filterValue.target.value.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches

    this.api.listbulkticketId(filterValue, this.page_mat_two, this.offset_mat_two).subscribe((result: any) => {
      this.dataSource_bulkview = new MatTableDataSource(result);
      this.dataSource_bulkview.paginator = this.b1Paginator;
      this.dataSource_bulkview.sort = this.b1Sort;
      //this.totallength = result[0]['count'];

      this.api.listbulkticketId_count(filterValue, this.page_mat_two, this.offset_mat_two).subscribe((result: any) => {
  
        this.totallength_mat_two = result[0]['count'];
      });

      
    })

   // this.dataSource_view.filter = filterValue;

    
  }

  applyFilter_dirnimi(filterValue: any) {
    filterValue = filterValue.target.value.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches

    this.api.listDirnimiticketId(filterValue, this.page_mat_three, this.offset_mat_three).subscribe((result: any) => {
      this.dataSource_dirnimiview = new MatTableDataSource(result);
      this.dataSource_dirnimiview.paginator = this.c1Paginator;
      this.dataSource_dirnimiview.sort = this.c1Sort;
      //this.totallength = result[0]['count'];

      this.api.listDirnimiticketId_count(filterValue, this.page_mat_three, this.offset_mat_three).subscribe((result: any) => {
  
        this.totallength_mat_three = result[0]['count'];
      });

      
    })

   // this.dataSource_view.filter = filterValue;

    
  }


  report_view() {

    this.selected_view.selected.forEach((item) => {
      var msg = JSON.stringify(item);
      var parsedarray = JSON.parse(msg);

      var args = {
        ticketId: parsedarray['ticketId'],
      };
      this.formaction.set_pduList_single(args);
      this.router.navigateByUrl('/dashboard/pduview')

    });
    this.selected_view.clear();
  }


  report() {
    this.selected_view.selected.forEach((item) => {
      var msg = JSON.stringify(item);
      var parsedarray = JSON.parse(msg);
      var args = {
        ticketId: parsedarray['ticketId'],
      };
      this.formaction.set_dirnimiList_single(args);
      this.router.navigateByUrl('/dashboard/dirnimiview')

    });
    this.selected_view.clear();
  }

    update_fn(){

      this.api.shipped_verified_list_verifycc().subscribe((result: any) => {
        console.log(result.length);
        this.pduRes_RejListTable = result;

        // alert(this.pduRes_RejListTable);

        for(let i=0; i < result.length; i++  ){
          console.log(result[i]['ticketId'])

        //  var ticketId = result[i]['ticketId'];
          var ccref = result[i]['ccrefno']

          this.api.ccrefUpdateStatus(ccref).subscribe((data: any) => {

            var args = {
              ticketId: result[i]['ticketId'],
              orderno: data['orderno'],
              date: data['date'],
              amount: data['amount'],
              verify_cc: 'verifiedcc'
            };
           // alert(JSON.stringify(args));

            this.api.ccrefUpdatetbl(args).subscribe((result: any) => {
             // console.log(result);
            })


            // if(i==10){
            //   this.overlay_bool = false;
            //   return
            // }

          });


            //this.ccrefnoStatus = data[0]['RefStatus'];


        }



      })




    }
}


export interface Element_View {
  ticketId: string;
  ccrefno: string;
  ccrefnostatus: string;
  admin_status: string;
  ccorder: string;
  ccdate: string;
  ccamount: string;
  ccverify: string;

}


export interface Element_BulkView {
  ticketId: string;
}

export interface Element_DirnimiView {
  ticketId: string;
}




